<h5 class="zint-card-title max-width-85">{{ label }}</h5>
@if(!previewOnly && (value === null || value === undefined)) {
  <div class="aira-nodata-icon-backdrop">
  <i class="fa-duotone fa-thin fa-message-xmark"></i>
    <p>No insights have been derived.</p>
  </div>
}
@else {
  <div class="pr-5" [ngClass]="{'blur-content': previewOnly}">   
    <truncate-text [inputText]="stringValue" [limit]="31"></truncate-text>
  </div>
}
